import BlogListCard from "../../components/BlogListCard"
import BlogMainBannerSection from "../../components/BlogMainBannerSection"
import BreadCrumb from "../../components/BreadCrumb"
import LocationDescription from "../../components/LocationDescription"

const Index = ({
    isLoading,
    blogCatDetail,
    blogList,
    nextPageUrl,
    isBlogsLoading,
    // onClickLoadMore,
    breadcrumbList,
    onPageChange,
    totalItems,
    totalPages,
    currentPage
}) => {

    return (
        <>
            <BlogMainBannerSection isLoading={isLoading} blogDetail={blogCatDetail} />
            <div className="container">
                <BreadCrumb list={breadcrumbList} />
            </div>

            <BlogListCard
                blogList={blogList}
                nextPageUrl={nextPageUrl}
                isBlogsLoading={isBlogsLoading}
                // onClickLoadMore={onClickLoadMore}
                isLoading={isLoading}
                onPageChange={onPageChange}
                totalPages={totalPages}
                totalItems={totalItems}
                currentPage={currentPage}
            />

            {blogCatDetail?.description &&
                <LocationDescription
                    name={blogCatDetail?.name}
                    description={blogCatDetail?.description} />
            }

        </>
    )

}
export default Index